export default __webpack_public_path__ + "static/media/Pickpocket's Bracers of the Burning Temple.6eafcd9d.jpg";